function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 223.17262,
    height: 189.16321,
    viewBox: "0 0 223.17262 189.16321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(-5.5902606,-8.711151)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 1
    },
    d: "m 27.262889,197.29553 c -9.537736,-1.68802 -17.3444367,-8.5132 -20.0287267,-17.51054 -2.191869,-7.34682 -2.191869,-145.790174 0,-153.136995 1.998293,-6.697983 6.4439647,-11.75165 13.2991337,-15.117938 l 5.729593,-2.8135626 h 87.000001 c 96.43048,0 89.94526,-0.43801 97.98119,6.6176246 2.10965,1.8523 4.88503,5.621093 6.1675,8.375096 2.13,4.573986 2.33262,6.370169 2.34154,20.757279 l 0.01,15.749998 h -25.34345 c -22.81543,0 -25.93263,0.20158 -31.25,2.02086 -11.90815,4.07423 -19.88908,11.44336 -25.71664,23.74528 -2.95647,6.24106 -3.18991,7.50227 -3.18991,17.233858 0,9.99998 0.17206,10.86028 3.61307,18.06545 4.54169,9.5099 11.55303,16.69118 20.63031,21.13031 l 6.75662,3.30424 27.25,0.30878 27.25,0.30878 -0.01,15.69122 c -0.009,14.32553 -0.21271,16.12703 -2.34154,20.6985 -1.28247,2.754 -4.05785,6.5228 -6.1675,8.37509 -8.01438,7.03672 -1.87762,6.60217 -95.48119,6.76112 -46.475001,0.0789 -86.300001,-0.17508 -88.500001,-0.56445 z m 145.402961,-69.0672 c -5.88451,-1.02697 -9.61569,-3.00444 -13.54101,-7.17652 -5.29002,-5.62258 -6.76377,-9.51077 -6.76016,-17.83532 0.004,-8.786138 2.11919,-13.791808 8.01657,-18.969768 7.22239,-6.34135 8.11233,-6.49503 37.71753,-6.51349 l 26.83589,-0.0167 1.91411,2.36079 c 1.74832,2.1563 1.91411,4.16048 1.91411,23.139208 0,18.96182 -0.167,20.98483 -1.9101,23.13922 -1.90379,2.35298 -1.98886,2.3613 -25.75,2.51784 -13.11195,0.0864 -25.90857,-0.20397 -28.43694,-0.64522 z",
    id: "path1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.cf1d0af4cd707be0426c85e3e2f5bb26.svg";
export { ForwardRef as ReactComponent };